import React, { createContext, useContext, useState, useEffect } from 'react';

const ChatContext = createContext();

export const useChat = () => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Charger les messages depuis localStorage au démarrage
  useEffect(() => {
    const savedMessages = localStorage.getItem('paperflow_messages');
    const savedSessionId = localStorage.getItem('paperflow_session_id');

    if (savedMessages) {
      try {
        setMessages(JSON.parse(savedMessages));
      } catch (error) {
        console.error('Erreur lors du chargement des messages:', error);
        localStorage.removeItem('paperflow_messages');
      }
    }

    if (savedSessionId) {
      setSessionId(savedSessionId);
    }
  }, []);

  // Sauvegarder les messages dans localStorage à chaque modification
  useEffect(() => {
    if (messages.length > 0) {
      localStorage.setItem('paperflow_messages', JSON.stringify(messages));
    } else {
      localStorage.removeItem('paperflow_messages');
    }
  }, [messages]);

  // Sauvegarder le sessionId dans localStorage
  useEffect(() => {
    if (sessionId) {
      localStorage.setItem('paperflow_session_id', sessionId);
    } else {
      localStorage.removeItem('paperflow_session_id');
    }
  }, [sessionId]);

  const addMessage = (message) => {
    setMessages(prev => [...prev, message]);
  };

  const clearMessages = () => {
    setMessages([]);
  };

  const newSession = () => {
    setSessionId(null);
    setMessages([]);
  };

  const setSessionIdAndMessages = (newSessionId, newMessages) => {
    setSessionId(newSessionId);
    setMessages(newMessages);
  };

  const value = {
    messages,
    setMessages,
    sessionId,
    setSessionId,
    isLoading,
    setIsLoading,
    addMessage,
    clearMessages,
    newSession,
    setSessionIdAndMessages
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export default ChatContext;